import parseISO from '@teetsh/app/src/utils/time/parseISO';
import { UserProfile, UserProfileApi } from '@teetsh/app/src/types/user';
import { notationSystems as defaultNotationSystems } from '@teetsh/app/src/utils/notationSystems/notationSystems';
import { getNotationsHelperAttributes } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/utils/getNotationsHelperAttributes';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

export function deserializeNotationSystem(notationSystems: NotationSystem[]) {
  return (notationSystems || [])
    .filter(n => n.id !== '%' && n.id !== '10' && n.id !== '20')
    .reduce(
      (acc, num) => ({
        ...acc,
        [num.id]: {
          ...num,
          ...getNotationsHelperAttributes(num),
        },
      }),
      defaultNotationSystems,
    );
}

export function deserializeUser(user: UserProfileApi): UserProfile {
  const notationSystems = user.notationSystems || [];
  return {
    ...user,
    expirationDate: parseISO(user.expirationDate),
    createdAt: user.createdAt ? parseISO(user.createdAt) : undefined,
    parrainages: (user.parrainages || []).map(p => ({
      ...p,
      date: parseISO(p.date),
    })),
    paymentHistory: (user.paymentHistory || []).map(p => ({
      ...p,
      products: p.products || [],
      date: parseISO(p.date),
    })),
    blockedAt: user.blockedAt ? parseISO(user.blockedAt) : undefined,
    notationSystems: deserializeNotationSystem(notationSystems),
  };
}

export function serializeUser(user: UserProfile) {
  const { createdAt, access, ...rest } = user;
  return {
    ...rest,
    notationSystems: Object.values(user.notationSystems),
    email: user.email,
    optin: user.optin,
    givenName: user.givenName,
    familyName: user.familyName,
    address1: user.address1,
    address2: user.address2,
    city: user.city,
    picture: user.picture,
    country: user.country,
    postcode: user.postcode,
    gender: user.gender,
    password: user.password,
    disableChat: user.disableChat,
    fonts: user.fonts,
    location: user.location,
    referencielId: user.referencielId,
    materials: user.materials,
    boLabels: user.boLabels,
    onboarding: user.onboarding,
  };
}
